export enum DotsLocation {
  left = "left",
  right = "right",
}
